import React from "react";
import Spinner from "./spinner";

interface EmptyPlaceholderProps {
  message?: string;
  className?: string;
  delay?: number;
  isLoading?: boolean;
}

const EmptyPlaceholder: React.FC<EmptyPlaceholderProps> = ({
  message = "No items to display",
  className = "",
  delay = 500,
  isLoading = false,
}) => {
  // Use a timeout to delay showing anything (spinner or message)
  const [showComponent, setShowComponent] = React.useState(false);

  React.useEffect(() => {
    // Only show something after the delay
    const timer = setTimeout(() => {
      setShowComponent(true);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [delay]);

  // Don't render anything during the initial delay
  if (!showComponent) {
    return null;
  }

  // After delay: show spinner if loading, message if not loading
  return (
    <div
      className={`flex items-center justify-center h-64 text-gray-500 ${className}`}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="text-center">
          <div className="text-lg font-medium mb-2">{message}</div>
          <div className="text-sm opacity-75">
            Items will appear here when available
          </div>
        </div>
      )}
    </div>
  );
};

export default EmptyPlaceholder;
